module.exports = __webpack_public_path__ + "img/mFinanse_logo_finanse_RGB.07d60eee.png";